<template>
  <div>
    <div class="title">Tour Records</div>
    <div class="table-page-search-wrapper" v-if="!isShowEdit">
      <a-form layout="inline">
        <a-row :gutter="10" type="flex">
          <a-col style="width: 200px;">
            <a-form-item label="Tour Code">
              <a-input v-model="queryParam.tourCode" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col style="width: 200px;">
            <a-form-item label="Booking No.">
              <a-input v-model="queryParam.bkrId" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col style="width: 180px;">
            <a-form-item label="Status">
              <a-select v-model="queryParam.bkrStatus" placeholder="Please select" @change="refreshCurrentPage" :dropdownMatchSelectWidth="false">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="0">New Booking</a-select-option>
                <a-select-option value="1111">Deposited</a-select-option>
                <a-select-option value="1222">Paid In Full</a-select-option>
                <a-select-option value="2">Invoiced</a-select-option>
                <a-select-option value="5">Completed</a-select-option>
                <a-select-option value="-1">Cancelled</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="reset">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="title-plate" v-if="!isShowEdit">
      <div class="btn-plate">
        <a-button type="primary" @click="isModalShow = true, bkrId = null"><a-icon type="plus"/> Add New</a-button>
      </div>
    </div>
    <s-table
      style="display: table;"
      ref="table"
      rowKey="bkrId"
      showQuickJumper
      :columns="!isShowEdit ? columns : mainColumns"
      :data="loadData"
      :rowSelection="rowSelectionConfig"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="tourCode" slot-scope="text, record"><span>{{ record.tourCode }}</span></span>
      <span slot="bkrId" slot-scope="text, record">
        <div style="display: flex;">
          <div v-if="record.recordType !== 3" style="display: flex;">
            <a :href="getOBSCodeUrl(record.bkrId)" target="_blank">{{ record.bkrId }}</a>
            <template v-if="record.recordType == 2">
               <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '1000px' }">
                  <template slot="title">
                    <div>Please confirm whether it is an order from this customer</div>
                  </template>
                  <div style="margin-left: 10px;color: #C00000;"><a-icon type="question-circle" /></div>
                </a-tooltip>
            </template>
          </div>
          <span v-else>{{ record.bkrId }}</span>
        </div>
      </span>
      <span slot="bkrStatus" slot-scope="text, record">
        <span v-if="record.bkrStatus == '0'">New Booking</span>
        <span v-if="record.bkrStatus == '1' && record.depositEnoughFlag == '1'">Deposited</span>
        <span v-if="record.bkrStatus == '1' && record.depositEnoughFlag == '2'">Paid In Full</span>
        <span v-if="record.bkrStatus == '2'">Invoiced</span>
        <span v-if="record.bkrStatus == '5'">Completed</span>
        <span v-if="record.bkrStatus == '-1'">Cancelled</span>
      </span>
      <span slot="startDate" slot-scope="text">
        {{ dateFormatB(text) }}
      </span>
      <template slot="recordType" slot-scope="text, record">
        <a-popconfirm
          v-if="record.recordType == 2"
          title="Are you sure?"
          @confirm="handleConfirm(record.bkrId)"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary" size="small">Confirm</a-button>
        </a-popconfirm>
      </template>
    </s-table>
    <a-modal
      title="Add New"
      :destroyOnClose="true"
      :visible="isModalShow"
      :maskClosable="false"
      @cancel="() => { this.isModalShow = false }"
    >
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="Booking No.">
          <a-input v-model="bkrId" placeholder="Please input" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" :loading="saving" @click="handleSave">
          Save
        </a-button>
        <a-button @click="() => { this.isModalShow = false }">
          Close
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CustomerApi from '@/api/api-cdb-custome-v2'

export default {
  name: 'CdbCustomerTourRecordList',
  components: {
    STable
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    globalCode: {
      type: String,
      required: true
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    },
    currentWebSiteType: {
      type: String,
      default: 'Signet'
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      // 加载中
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      currentTourRecordIndex: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { customerId: this.customerId, bkrStatus: '', tourCode: '', bkrId: ''},
      // Status 状态
      statusList:[],
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          align:'center',
          width: '35px',
        },
        {
          title: 'Booking No.',
          dataIndex: 'bkrId',
          scopedSlots: { customRender: 'bkrId' }
        },
        {
          title: 'Tour Code',
          dataIndex: 'tourCode',
          scopedSlots: { customRender: 'tourCode' }
        },
        {
          title: 'Date',
          dataIndex: 'createDate',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Status',
          dataIndex: 'bkrStatus',
          width: '100px',
          scopedSlots: { customRender: 'bkrStatus' }
        },
        {
          title: 'Price',
          dataIndex: 'roomPrice',
          customRender: (value) => {
            return this.moneyFormatThousandNoZero(this.moneyFormatThousand(value))
          }
        },
        {
          title: '',
          dataIndex: 'recordType',
          scopedSlots: { customRender: 'recordType' }
        },
      ],
      mainColumns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          align:'center',
          width: '35px',
        },
        {
          title: 'Booking No.',
          dataIndex: 'bkrId',
          scopedSlots: { customRender: 'bkrId' }
        },
        {
          title: 'Tour Code',
          dataIndex: 'tourCode',
          scopedSlots: { customRender: 'tourCode' }
        },
        {
          title: 'Date',
          dataIndex: 'createDate',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Status',
          dataIndex: 'bkrStatus',
          width: '100px',
          scopedSlots: { customRender: 'bkrStatus' }
        },
        {
          title: 'Price',
          dataIndex: 'roomPrice',
          customRender: (value) => {
            return this.moneyFormatThousandNoZero(this.moneyFormatThousand(value))
          }
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // parameter.pageSize = 100
        parameter.curPage = parameter.pageNo
        const queryParam = Object.assign({}, this.queryParam)
        if (queryParam.bkrStatus == '1111') {
          queryParam.bkrStatus = '1'
          queryParam.depositEnoughFlag = '1'
        } else if (queryParam.bkrStatus == '1222') {
          queryParam.bkrStatus = '1'
          queryParam.depositEnoughFlag = '2'
        } else {
          queryParam.depositEnoughFlag = ''
        }
        return CustomerApi.queryTourRecord(Object.assign(parameter, queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      superaSelectedRowKeys: [],
      selectedBkcIdList: [],
      isModalShow: false,
      bkrId: null
    }
  },
  computed: {
    rowSelectionConfig () {
      if (this.isMainShow) {
        return null
      }
      let selectedRowKeys
      if (this.currentWebSiteType == 'Signet') {
        selectedRowKeys = this.selectedRowKeys
      } else {
        selectedRowKeys = this.superaSelectedRowKeys
      }
      return {
        selectedRowKeys: selectedRowKeys,
        onChange: this.onSelectChange,
        columnWidth: '32px'
      }
    }
  },
  mounted () {
    this.loadInitData()
  },
  methods: {
    async loadInitData () {
    },
    getOBSCodeUrl (bkrId) {
      const env = process.env.NODE_ENV
      if (env === 'production' || env === 'test') {
        return process.env.VUE_APP_OBS_PUBLIC_URL + '/obs_queryBooking.do?bkrId=' + bkrId
      } else {
        // 开发环境
        return `https://nike.supernettours.com/obs_queryBooking.do?bkrId=${ bkrId }`
      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedBkcIdList = selectedRows.map(row => row.bkcId)
      if (this.currentWebSiteType == 'Signet') {
        this.selectedRowKeys = selectedRowKeys
      } else {
        this.superaSelectedRowKeys = selectedRowKeys
      }
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 通知父组件更新
    notifyTourInfoChange () {
      this.$emit('change')
    },
    // 查询
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    // 重置查询条件
    reset () {
      this.queryParam = { customerId: this.customerId, tourCode: '', bkrId: '', bkrStatus: ''}
      this.refreshCurrentPage()
    },
    handleSave () {
      this.saving = true
      CustomerApi.addTourRecord(this.globalCode, this.bkrId).then(res => {
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.mixinProcessSuccessNotification('Save success !')
          this.saving = false
          this.isModalShow = false
          this.refreshCurrentPage()
        }
      }).catch((e) => {
        if (e && e.response && e.response.data) {
          this.$notification['error']({
            message: 'Error',
            description: `${e.response.data.errorMessage}`
          })
        }
        this.saving = false
      })
    },
    handleConfirm (bkrId) {
      this.bkrId = bkrId
      this.handleSave()
    }
  },
  watch: {
    customerId(newVal) {
      this.queryParam.customerId = newVal
      if (this.$refs.table) {
        this.$refs.table.loadData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ::v-deep .ant-table-pagination {
  display: none !important;
} */
.plate-title {
   font-weight: 600;
   font-size: 1rem;
   // padding: 20px 0 8px 0;
   line-height: 32px;
 }
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 3px;
}
// ::v-deep  .ant-select-selection {
//   width: 120px;
// }
::v-deep .ant-form-inline  {
  margin-bottom: 10px;
}
</style>